export default __webpack_public_path__ + "static/media/pic6.eda8c50c.jpg";